import ReadOnlyService from '../base/ReadOnlyService';

class Template extends ReadOnlyService {
  constructor() {
    super('templates');
  }
}

export default new Template();
